export default "__VITE_ASSET__gYLvKWEv__"